module.exports = __webpack_public_path__ + "img/life-orientation.94fba4a2.svg";